import { render, staticRenderFns } from "./TaskManage.vue?vue&type=template&id=3fef5a9c&scoped=true&"
import script from "./TaskManage.vue?vue&type=script&lang=js&"
export * from "./TaskManage.vue?vue&type=script&lang=js&"
import style0 from "./TaskManage.vue?vue&type=style&index=0&id=3fef5a9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fef5a9c",
  null
  
)

export default component.exports